import { render } from "./DownloadSection.vue?vue&type=template&id=3e249f7c&scoped=true"
import script from "./DownloadSection.vue?vue&type=script&lang=js"
export * from "./DownloadSection.vue?vue&type=script&lang=js"

import "./DownloadSection.vue?vue&type=style&index=0&id=3e249f7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e249f7c"]])

export default __exports__